module.exports = __webpack_public_path__ + "img/result-index-img01.c6b19a3a.svg";